import { colors } from '@lmc/common/constants'

export const tableStyles = {
  table: {
    marginBottom: 30
  },
  tableHeader: {
    bold: true,
    fontSize: 13,
    color: colors.black
  },
  tableHeaderSmall: {
    fontSize: 12,
    color: colors.black
  },
  tableText: {
    fontSize: 10,
    color: colors.black,
    wordWrap: 'break-word'
  },
  tableTextSmall: {
    fontSize: 7,
    color: colors.black
  },
  whiteTableText: {
    fontSize: 7,
    alignment: 'center',
    color: colors.white
  },
  center: {
    alignment: 'center'
  },
  h1: {
    fontSize: 24,
    semibold: true
  },
  h2: {
    color: colors.darkgrey,
    fontSize: 16,
    semibold: true
  },
  h3: {
    fontSize: 14,
    bold: true
  },
  quote: {
    italics: true
  },
  normal: {
    fontSize: 11
  },
  small: {
    color: colors.darkgrey,
    fontSize: 8
  }
}

export default tableStyles
